import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';
export let INJECTION_TOKEN = new InjectionToken('app.config');

export let InjectionTokenProvider = {
  provider: INJECTION_TOKEN,
  useValue: environment,
};
